import star from "../assets/images/star.png";
import arrow from "../assets/images/arrow-icon.png";
import appImg from "../assets/images/Appstore.png";
import splashScreen from "../assets/images/splash-screen.png";
import arboxLogo from "../assets/images/arbox-logo.png";
import userapplogo from "../assets/images/user-app-logo.png";
import headerBtns from "../assets/images/headerbuttons.png";
import userImage from "../assets/images/Oval.png";
import feed1 from "../assets/images/Feed1.png";
import feed2 from "../assets/images/Feed2.png";
import homeInactivenav from "../assets/images/home-inactive.png";
import profilenav from "../assets/images/person.png";
import classesnav from "../assets/images/calendar.png";
import shopnav from "../assets/images/cart.png";
import morenav from "../assets/images/more.png";
import phoneImage from "../assets/images/phone.png";
import emailImage from "../assets/images/email.png";
import websiteImage from "../assets/images/Website.png";
import expireImage from "../assets/images/expire.png";
import addcalendarImage from "../assets/images/addcalendar.png";
import ticketImage from "../assets/images/ticket.png";
import downarrow from "../assets/images/down-arrow.png";
import searchImg from "../assets/images/schedule.png";
import calendarLeft from "../assets/images/left.png";
import calendarRight from "../assets/images/right.png";
import availBooking from "../assets/images/booking.png";
import yogaCard from "../assets/images/yoga-card.png";

export default function AppPreview(props) {
  const { logo, splash, backgroundImg, appleIcon, appName } = props;
  return (
    <div className="app-preview-wrapper">
      <div className="app-name-wrapper">
        <div className="app-logo">
          {/* <img src={backgroundImg || appImg} /> */}
          <img src={appleIcon || appImg} />
        </div>
        <div className="app-detail-wrapper">
          <h3>{appName}</h3>
          <h4>Arbox LTD</h4>
          <p>Designed for iPhone</p>
          <div className="ratings-wrapper">
            <div className="ratings-stars">
              <img src={star} />
              <img src={star} />
              <img src={star} />
              <img src={star} />
              <img src={star} />
            </div>
            <div className="ratings-text">5.0 1906 Ratings</div>
          </div>
          <p>Free</p>
          <button className="btn btn-outline">
            View in Mac App Store
            <img src={arrow} />
          </button>
        </div>
      </div>

      <div className="app-preview-screens-wrapper">
        <div className="app-preview-screens-1 app-preview-screens">
          <img src={splash || splashScreen} />
          <p>
            Powered by <img src={arboxLogo} />
          </p>
        </div>

        <div className="app-preview-screens-2 app-preview-screens">
          <div className="app-preview-bg">
            <div className="app-login-screen-wrapper">
              <div className="user-app-logo-wrapper">
                <img src={logo || userapplogo} />
              </div>
              <div className="user-login-form">
                <div className="input-wrapper">
                  <label>Email</label>
                  <input
                    type="text"
                    value="example@arboxapp.com"
                    onChange={() => { }}
                  />
                </div>

                <div className="input-wrapper">
                  <label>Password</label>
                  <input
                    type="text"
                    value="**********"
                    onChange={() => { }}
                  />
                </div>

                <button className="btn btn-outline">Submit</button>
              </div>

              <div className="forgot-password">
                <p>Forgot Password?</p>
                <p>Terms of Use & Privacy Policy</p>
              </div>
            </div>
          </div>
        </div>

        <div className="app-preview-screens-3 app-preview-screens">
          <div className="app-preview-bg">
            <div className="dashboard-header">
              <div className="header-btns">
                <img src={headerBtns} />
              </div>
              <div className="user-name-img">
                <img src={userImage} />
                <div className="username">Hey Avi</div>
                <div className="appname">Welcome to Kultcha</div>
              </div>
            </div>

            <div className="feed-images">
              <div className="feed-img">
                <img src={feed1} className="img-fluid" />
              </div>
              <div className="feed-img">
                <img src={feed2} className="img-fluid" />
              </div>
            </div>

            <div className="navlinks">
              <div className="nav-icon active-nav">
                <svg width="11" height="11" viewBox="0 0 11 11" fill="var(--app-main-color)" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.1353 4.50136L5.30349 0.750793L0.471664 4.50136" />
                  <path d="M10.1353 4.50136L5.30349 0.750793L0.471664 4.50136" strokeWidth="0.358935" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.50454 4.08221V10.1591H6.66847V6.17769H4.04248V10.1591H1.10137V4.08221" />
                  <path d="M9.50454 4.08221V10.1591H6.66847V6.17769H4.04248V10.1591H1.10137V4.08221" strokeWidth="0.358935" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

                <div>Feed</div>
              </div>
              <div className="nav-icon">
                <img src={profilenav} />
                <div>My Profile</div>
              </div>
              <div className="nav-icon">
                <img src={classesnav} />
                <div>Classes</div>
              </div>
              <div className="nav-icon">
                <img src={shopnav} />
                <div>Shop</div>
              </div>
              <div className="nav-icon">
                <img src={morenav} />
                <div>More</div>
              </div>
            </div>
          </div>
        </div>

        <div className="app-preview-screens-4 app-preview-screens">
          <div className="app-preview-bg">
            <div className="dashboard-header">
              <div className="user-name-img">
                <img src={userImage} />
                <div className="appname">
                  We are open 24/7, including indoor and outdoor pool, gym with
                  the most advanced fitness machines and 4 seperated studios
                  with tunes of classes, such as Yoga, TRX, pilates and more
                </div>
              </div>
            </div>

            <div className="contact-nav">
              <img src={phoneImage} />
              <img src={websiteImage} />
              <img src={emailImage} />
            </div>

            <div className="tabs-nav">
              <div className="act-tab">My Memberships</div>
              <div>My Forms</div>
            </div>

            <div className="app-card-wrapper">
              <div className="app-card-header">
                <div>Yearly Membership</div>
                <span>Active</span>
              </div>
              <div className="app-card-item">
                <img src={expireImage} />
                Expirted At May 31, 20
              </div>
              <div className="app-card-item">
                <img src={addcalendarImage} />5 Future Bookings
              </div>
            </div>

            <div className="app-card-wrapper">
              <div className="app-card-header">
                <div>10 punches, unlimited</div>
                <span>Active</span>
              </div>
              <div className="app-card-item">
                <img src={expireImage} />
                Expirted At May 31, 20
              </div>
              <div className="app-card-item">
                <img src={ticketImage} />
                2/10 punches left
              </div>
              <div className="app-card-item">
                <img src={addcalendarImage} />
                Expirted At May 31, 20
              </div>
            </div>

            <div className="navlinks">
              <div className="nav-icon ">
                <img src={homeInactivenav} />
                <div>Feed</div>
              </div>
              <div className="nav-icon active-nav">
                <svg width="11" height="12" viewBox="0 0 11 12" fill="var(--app-main-color)" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.6492 11.134H0.985596C1.11813 8.72758 4.21912 9.07151 4.66952 7.8291V6.71889C4.48418 6.61247 4.16632 5.97838 4.11351 5.42272C3.98098 5.42272 3.74181 5.26475 3.66312 4.68328C3.6362 4.36519 3.79565 4.18032 3.87434 4.12765C3.37114 2.14474 3.6362 0.426209 5.99479 0.373535C6.57875 0.373535 7.02919 0.531552 7.21451 0.849644C8.91045 1.08718 8.40728 3.38715 8.14222 4.12765C8.24785 4.18032 8.38038 4.36519 8.35449 4.68328C8.30164 5.26475 8.06248 5.42272 7.90405 5.42272C7.85021 5.97838 7.53236 6.61247 7.34704 6.71889V7.8291C7.42407 8.02959 7.56941 8.18872 7.75954 8.32483" />
                  <path d="M10.6492 11.134H0.985596C1.11813 8.72758 4.21912 9.07151 4.66952 7.8291V6.71889C4.48418 6.61247 4.16632 5.97838 4.11351 5.42272C3.98098 5.42272 3.74181 5.26475 3.66312 4.68328C3.6362 4.36519 3.79565 4.18032 3.87434 4.12765C3.37114 2.14474 3.6362 0.426209 5.99479 0.373535C6.57875 0.373535 7.02919 0.531552 7.21451 0.849644C8.91045 1.08718 8.40728 3.38715 8.14222 4.12765C8.24785 4.18032 8.38038 4.36519 8.35449 4.68328C8.30164 5.26475 8.06248 5.42272 7.90405 5.42272C7.85021 5.97838 7.53236 6.61247 7.34704 6.71889V7.8291C7.42407 8.02959 7.56941 8.18872 7.75954 8.32483C9.67954 9.17674 10.5896 9.70606 10.6492 11.134Z" strokeWidth="0.354991" strokeMiterlimit="10" strokeLinecap="round" />
                  <path d="M10.304 11.9778L7.54297 9.56189H8.23323L9.26862 9.90702L10.304 10.9424L10.6491 11.9778H10.304Z" />
                </svg>
                <div>My Profile</div>
              </div>
              <div className="nav-icon">
                <img src={classesnav} />
                <div>Classes</div>
              </div>
              <div className="nav-icon">
                <img src={shopnav} />
                <div>Shop</div>
              </div>
              <div className="nav-icon">
                <img src={morenav} />
                <div>More</div>
              </div>
            </div>
          </div>
        </div>

        <div className="app-preview-screens-5 app-preview-screens">
          <div className="app-preview-bg">
            <div className="app-name-search">
              <div className="app-nam">
                BS Name
                <img src={downarrow} />
              </div>
              <div className="app-search">
                <img src={searchImg} />
              </div>
            </div>

            <div className="classes-tabs">
              <div className="classes-active">Class Schedule</div>
              <div>My Classes</div>
            </div>

            <div className="calendar-wrapper">
              <div className="month-wrapper">
                <div>
                  <img src={calendarLeft} />
                </div>
                <div>March</div>
                <div>
                  <img src={calendarRight} />
                </div>
              </div>

              <div className="days-wrapper">
                <div>
                  <div className="day-main">Mon</div>
                  <div>11</div>
                </div>
                <div>
                  <div className="day-main">Tue</div>
                  <div>12</div>
                </div>
                <div>
                  <div className="day-main">Wed</div>
                  <div>13</div>
                </div>
                <div>
                  <div className="day-main">Thu</div>
                  <div>14</div>
                </div>
                <div>
                  <div className="day-main">Fri</div>
                  <div className="current-day">15</div>
                </div>
                <div>
                  <div className="day-main">Sat</div>
                  <div className="booking-dot">16</div>
                </div>
                <div>
                  <div className="day-main">Sun</div>
                  <div>17</div>
                </div>
              </div>
            </div>

            <div className="bookings-detail">
              <div className="app-booking">
                <img src={availBooking} className="img-fluid" />
              </div>
              <div className="app-booking booked">
                <img src={yogaCard} className="img-fluid" />
                <span>Booked</span>
              </div>
            </div>

            <div className="navlinks">
              <div className="nav-icon ">
                <img src={homeInactivenav} />
                <div>Feed</div>
              </div>
              <div className="nav-icon">
                <img src={profilenav} />
                <div>My Profile</div>
              </div>
              <div className="nav-icon active-nav">
                <svg width="11" height="12" viewBox="0 0 11 12" fill="var(--app-main-color)" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.25709 1.93848H0.719689C0.598722 1.93848 0.500061 1.9864 0.500061 2.11219V10.9298C0.500061 11.0556 0.580706 11.1395 0.701673 11.1395H9.96295C10.0831 11.1395 10.1637 11.0556 10.1637 10.9298V2.11219C10.1637 1.9864 10.065 1.93848 9.94408 1.93848H8.40668M7.56506 1.93848H3.1356H7.56506ZM0.500061 3.91013H10.1637H0.500061Z" />
                  <path d="M2.25709 1.93848H0.719689C0.598722 1.93848 0.500061 1.9864 0.500061 2.11219V10.9298C0.500061 11.0556 0.580706 11.1395 0.701673 11.1395H9.96295C10.0831 11.1395 10.1637 11.0556 10.1637 10.9298V2.11219C10.1637 1.9864 10.065 1.93848 9.94408 1.93848H8.40668M7.56506 1.93848H3.1356M0.500061 3.91013H10.1637" stroke="white" strokeWidth="0.34513" strokeMiterlimit="10" strokeLinejoin="round" />
                  <path d="M8.18564 2.81434H7.74638C7.62542 2.81434 7.52676 2.71593 7.52676 2.59527V1.28084C7.52676 1.16018 7.62542 1.06177 7.74638 1.06177H8.18564C8.30661 1.06177 8.40527 1.16018 8.40527 1.28084V2.59527C8.40527 2.71593 8.30661 2.81434 8.18564 2.81434ZM2.91456 2.81434H2.4753C2.35434 2.81434 2.25568 2.71593 2.25568 2.59527V1.28084C2.25568 1.16018 2.35434 1.06177 2.4753 1.06177H2.91456C3.03553 1.06177 3.13419 1.16018 3.13419 1.28084V2.59527C3.13419 2.71593 3.03553 2.81434 2.91456 2.81434Z" fill="white" strokeWidth="0.34513" strokeMiterlimit="10" strokeLinejoin="round" />
                  <path d="M5.33197 4.849L5.33197 9.66859" stroke="white" strokeWidth="0.34513" />
                  <path d="M3 7L7.83182 7" stroke="white" strokeWidth="0.34513" />
                </svg>

                <div>Classes</div>
              </div>
              <div className="nav-icon">
                <img src={shopnav} />
                <div>Shop</div>
              </div>
              <div className="nav-icon">
                <img src={morenav} />
                <div>More</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
